import React from "react";
import "./Fallback.css";

const Fallback = () => {
  return (
    <div className="fallback-container">
      <h1 className="loading-text">Loading</h1>
      <div className="dots">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <p className="loading-message">Please wait while we load the content.</p>
    </div>
  );
};

export default Fallback;
